import AppBaseComponent from "../../../components/AppBaseComponent";
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {Chart} from "react-google-charts";
import Ax from "../../../components/hoc/Ax";
import Loader from "../../../components/ui/Loader/Loader";
import TapSelect from "../../../components/ui/TapSelect";
import HttpAPICall from '../../../services/HttpAPICall';
import tapIcon from "../../../services/TapIcon";
import React from "react";
import { INVENTORY_API_BASE_URL_2 } from "../../../services/TapApiUrls";
import * as actions from "../../../store/actions/index";
import moment from "moment";
import UpdateMyDashboardForm from "../../settings/configurationGeneral/myDashboard/UpdateMyDashboardForm";
import DateService from "../../../services/DateService";

class PurchaseWidget extends AppBaseComponent {

    constructor(props) {
        super(props);
        this.state                      =   {
            loading                     :      false,
            data                        :       [],
            remark_day                  :       0,
            remark_time                 :       '',
            all_warehouses              :       [],
            user_filter                 :   [
                {value  :   'tagged_me',        label : 'My Tagged PO'},
                {value  :   'created_by_me',    label : 'PO Created By Me'},
            ],
            filterForm                  :       {
                warehouse_id            :       '',
                tagged_user_filter      :       ''
            }
        }
        this.updateMyDashboardRef      =   React.createRef();
    }

    componentDidMount(){
        this.initilaizeFormFilter(this.props);
        if (localStorage.getItem('purchaseOrderWidget')) {
            let purchaseOrderData = JSON.parse(localStorage.getItem('purchaseOrderWidget'));
            if (purchaseOrderData) {
                 let differenceInSeconds =   DateService.differenceInSeconds(moment(purchaseOrderData.time, 'DD-MM-YYYY HH:mm A').format());
               
                 if (differenceInSeconds > 86400) {
                    localStorage.removeItem('purchaseOrderWidget')
                    setTimeout(() => {
                        this.getPurchaseOrderListing();
                    }, 1000 * (this.props.indexProps ? this.state.indexProps : 12));
                    
                } else {
                    this.setState({
                        data            :       purchaseOrderData.data,
                        remark_time     :       purchaseOrderData.time,  
                })

                }
            }else{
                setTimeout(() => {
                    this.getPurchaseOrderListing();
                }, 1000 * (this.props.indexProps ? this.state.indexProps : 12));
            }
        } else {
            setTimeout(() => {
                this.getPurchaseOrderListing();
            }, 1000 * (this.props.indexProps ? this.state.indexProps : 12));
        }
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.all_warehouses !== this.props.all_warehouses || nextProps.dashboard_filter_warehouse_id !== this.props.dashboard_filter_warehouse_id || nextProps.clearDashboardFilter !== this.props.clearDashboardFilter) {
            this.initilaizeFormFilter(nextProps);
        }
    }

    initilaizeFormFilter               =   (props)  =>  {
        if(props.all_warehouses.length > 0) {
            this.setState({
                all_warehouses                  :   props.all_warehouses
                    ? props.all_warehouses.map((m) => { return { value: m.id, label: `${m.name} (${m.code})` }}) 
                    : [],
            }, () => {
                
                 if(this.props.dashboard_filter_warehouse_id || props.clearDashboardFilter == 'yes'){
                   
                    this.setState({
                        filterForm              :   {
                            warehouse_id                :       props.dashboard_filter_warehouse_id,
                            tagged_user_filter          :        ''
                        },
                        
                    },() =>  this.getPurchaseOrderListing())
                }
                
            });
        }
    }

    getPurchaseOrderListing                =   (reload=false)  =>  {
        this.setState({loading: true});
        let params          =   {filter_warehouse_id : this.state.filterForm.warehouse_id ,reload : reload ? 'reload' : false,tagged_user_filter:this.state.filterForm.tagged_user_filter};
        HttpAPICall.withAthorization('GET', INVENTORY_API_BASE_URL_2 + '/purchase_order_status_widget_data', this.props.access_token, {...params}, {} , (response) => {
            this.setState({data : response.data.data,remark_time : response.data.time})
            if(!this.state.filterForm.warehouse_id  && !this.state.filterForm.tagged_user_filter){
                localStorage.setItem('purchaseOrderWidget',JSON.stringify(response.data));
            }
            if(reload !== false){
                localStorage.setItem('purchaseOrderWidget',JSON.stringify(response.data));
            }
        }).then(() => this.setState({loading: false}));
    }

    pinMyDashboardHandler = (widgetData=null) => {
        this.updateMyDashboardRef.current.updateMyDashboardModalInit(widgetData,{key:"purchase_order",name:"Purchase Order"})
    }

    render                      =   ()  =>  {
        let widgetData = this.props.widget_keys && this.props.widget_keys.length > 0 && this.props.widget_keys.find(st => {return("purchase_order" == st.key)}) ? this.props.widget_keys.find(st => {return(st.key == "purchase_order")})  : null;
        return (<div className="card mt-3">
            <div className="card-body">
                <div className="row">
                    <div className="col-5">
                        <h6 className="fw-bold primary_color">Purchase Order  </h6>
                    </div>
                    <div className="col-3 p0">
                        <TapSelect
                            options={this.state.user_filter}
                            isSearchable={true}
                            isClearable={true}
                            value={this.state.user_filter.find(m => m.value == this.state.filterForm.tagged_user_filter)}
                            placeholder="All PO"
                            containerHeight="33px"
                            fontSize="93%"
                            width="99%"
                            changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'filterForm', 'tagged_user_filter', () => this.getPurchaseOrderListing())}
                        />
                    </div>
                    <div className="col-3 p0">
                        <TapSelect
                            options={this.state.all_warehouses}
                            isSearchable={true}
                            isClearable={true}
                            value={this.state.all_warehouses.find(m => m.value == this.state.filterForm.warehouse_id)}
                            placeholder="All Warehouses"
                            containerHeight="33px"
                            fontSize="93%"
                            changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'filterForm', 'warehouse_id', () => this.getPurchaseOrderListing())}
                        />
                    </div>
                    <div className="col-1 px-0 mx-0 text-center">
                        <tapIcon.imageIcon icon={tapIcon.ListActionIcon} alt="action-icon" className="img-fluid px-2 btn btn-light btn-block" data-bs-toggle="dropdown" href="#" role="button" aria-expanded="false" />
                        <ul className="dropdown-menu dropdown-menu-end">
                            <li className="dropdown-item" style={{ cursor: "pointer" }} onClick={() => this.getPurchaseOrderListing(true)}> Refresh</li>
                            <li className="dropdown-item" style={{ cursor: "pointer" }} onClick={() => this.pinMyDashboardHandler(widgetData)}>{!widgetData ? "Pinned to My Dashboard" : "Unpinned from My Dashboard"}</li>
                        </ul>
                    </div>
                </div>
                {this.state.loading
                    ? <Loader />
                    : (<Ax>
                        {this.state.data && this.state.data.length == 0
                            ? <div className="row mt-2 align-items-center">
                                <div className="col-sm-12 text-center">
                                    No Record
                                </div>
                            </div>
                            : <div className="row mt-2 align-items-center">
                                <div className="col-sm-6">
                                    <table className="table table-hover table-bordered table-borderless bg-white my-2">
                                        <thead className="table-secondary">
                                            <tr className="text-end">
                                                <th style={{ width: "40%" }} className="text-start" >Status</th>
                                                <th style={{ width: "30%" }}>Transaction</th>
                                                <th style={{ width: "30%" }}>Quantity</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.loading
                                                ? (<tr>
                                                    <td className="text-center" colSpan="3"><Loader /></td>
                                                </tr>)
                                                : <Ax>
                                                    {this.state.data && this.state.data.length > 0 ?
                                                        this.state.data.map((st, key) => {
                                                            let obj = { 'search_status_ids': st?.id?.map(i => i) };
                                                            if (this.state.data && this.state.filterForm.warehouse_id) {
                                                                obj['search_warehouse_ids'] = this.state.filterForm.warehouse_id;
                                                            }
                                                            if (this.state.data && this.state.filterForm.tagged_user_filter != '') {
                                                                obj['tagged_user'] = this.state.filterForm.tagged_user_filter;
                                                            }
                                                            return (<tr>
                                                                <th>{st.name ? st.name : "-"}</th>
                                                                <td className="text-end"><Link target='_blank' to={{ pathname: "/purchase_order_list", search: "?" + new URLSearchParams(obj).toString() }}>{st.total_po ? st.total_po : 0}</Link></td>
                                                                <td className="text-end"><Link target='_blank' to={{ pathname: "/report/item_wise_purchase_order", search: "?" + new URLSearchParams(obj).toString() }}>{st.total_items ?? 0}</Link></td>
                                                            </tr>)
                                                        })
                                                        : null}
                                                </Ax>
                                            }
                                        </tbody>
                                    </table>

                                </div>
                                <div className="col-6 p0">
                                    <div className="mt-3 mb-1">
                                        {this.state.loading
                                            ? <Loader />
                                            : (<Chart
                                                width={'100%'}
                                                height={'100%'}
                                                chartType="BarChart"
                                                loader={`<div>Loading Chart</div>`}
                                                data={[['Status', `Transaction`]].concat(this.state.data?.map((d) => { return [d.name, parseInt(d.total_po)]; }))}
                                                options={{
                                                    legend: { position: 'top' },
                                                    colors: ['#53a8e3'],
                                                    isStacked: true,
                                                    chartArea: { width: '100%', left: '90', height: '100%' }
                                                }}
                                                rootProps={{ 'data-testid': '1.5' }}
                                            />)}
                                    </div>
                                </div>


                                <div className="col-sm-12 text-muted fs11">
                                    Report as of {this.state.remark_time}
                                </div>
                            </div>
                        }
                    </Ax>)}

            </div>
            <UpdateMyDashboardForm
                    ref={this.updateMyDashboardRef}
               />
        </div>);
    }

}


const mapStateToProps = state => {
    return {
        access_token            :   state.auth.access_token,
        all_warehouses          :   state.app && state.app.warehouses ? state.app.warehouses : [],
        widget_keys             :   state.app && state.app.user_info && state.app.user_info.widget_keys && state.app.user_info.widget_keys.length > 0 ? state.app.user_info.widget_keys : [],
    };
};


export default connect(mapStateToProps)(PurchaseWidget);